export const buildProDemoScheduleLink = (mediumId, availabilityId) => {
  return `${window.location.origin}/special-events?medium_id=${mediumId}&availability_id=${availabilityId}`;
};

export const buildProDemoMediumLink = (mediumId) => {
  return `${window.location.origin}/special-events?medium_id=${mediumId}`;
};
